import { UserInfo } from 'api/services/user';
import { UserRoles } from 'types/user';

const getLink = (user_id: number | string, type: string, path: string) => {
    const url = new URL(`https://erp.og1.ru/${path}`);
    url.searchParams.set('modals', `[{"type":"user_card","id":${user_id},"userType":"${type}","layer":1}]`);
    return url.toString();
};

export const gteUserLink = (userInfo: UserInfo): string | undefined => {
    const isStudent = userInfo?.userRoles?.includes(UserRoles.STUDENT);
    if (isStudent && userInfo.externalId) {
        return getLink(`"${userInfo.externalId}"`, 'student', 'choose/student');
    }
    return undefined;
};
